window.ppsettings = window.ppsettings || {};
window.ppsettings.imageFallback = getComputedStyle(document.documentElement).getPropertyValue("--image-fallback-path").trim().replace(/^["']|["']$/g, "");

var siteLanguage = "de";
var langObject = $("[data-language-obj]").data("language-obj");
if(!!langObject){
    siteLanguage = langObject.code;
}

var gaProperty = "UA-411685-51";
var disableStr = 'ga-disable-' + gaProperty;